attribute float absMag;
attribute float appMag;

attribute float brightness;
attribute vec3 colour;
attribute vec3 sPosition;
attribute float starSize;

uniform float uSizeSystem;
uniform float uCoordSystem;
uniform float uMinSize;
uniform float uDistanceMult;
uniform sampler2D uDistort;

varying vec3 vColour;
varying float vBrightness;

vec2 screenSpaceFromPos(vec4 inSsPos){
    vec4 ssPos=inSsPos;
    ssPos.xyz/=ssPos.w;
    ssPos.xy=.5+ssPos.xy*.5;
    return ssPos.xy;
}

void main(){
    
    vec4 mvCposition=modelViewMatrix*vec4(position,1.);
    vec4 mvSposition=modelViewMatrix*vec4(sPosition,1.);
    vec4 finalPosition=mix(mvCposition,mvSposition,uCoordSystem);
    
    vec4 centerPosition=projectionMatrix*finalPosition;
    
    vec2 ssP=screenSpaceFromPos(centerPosition);
    vec3 distort=texture2D(uDistort,ssP).rgb;
    
    float size=mix(absMag,appMag,uCoordSystem);
    //float size = starSize;
    
    gl_PointSize=max(size*(uDistanceMult/-finalPosition.z),uMinSize);
    //gl_PointSize = max(sqrt(size * (uDistanceMult / -finalPosition.z)), uMinSize);
    
    gl_Position=projectionMatrix*finalPosition;
    
    vBrightness=distort.r;
    vColour=colour;
}